import {BrowserRouter, Route, Routes, useLocation} from "react-router-dom";
import "./assets/css/margins-paddings.css";
import Version01 from "./components/pages/version-01";
import AOS from "aos";
import {useEffect} from "react";
import "./assets/css/aos.css";
import Author from "./components/pages/author";
import Characters from "./components/pages/characters";
import AllBlog from "./components/pages/all-blog";
import SingleBlog from "./components/pages/single-blog";

import footerData from "./data/footer.json";
import headerData from "./data/header.json";
import SingleBookCharacters from "./components/pages/single-book-characters";

function ScrollToTop() {
  const {pathname} = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
function App() {
  const {header, headerv2, headerv3} = headerData;
  const {footer} = footerData;
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <div className="section-wrapper">
      <div id="preLoader"></div>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={<Version01 header={header} footer={footer} />}
          />
          <Route
            path="books/:slug"
            element={<SingleBlog headerv3={headerv3} footer={footer} />}
          />
          <Route
            path="author"
            element={<Author headerv3={headerv3} footer={footer} />}
          />
          <Route
            path="characters"
            element={<Characters headerv3={headerv3} footer={footer} />}
          />
          <Route
            path="characters/:slug"
            element={
              <SingleBookCharacters headerv3={headerv3} footer={footer} />
            }
          />
          <Route
            path="books"
            element={<AllBlog headerv3={headerv3} footer={footer} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
